export const SET_SCANNER_PARAMS = 'SET_SCANNER_PARAMS';
export const SET_FILTERS_FROM_URL = 'SET_FILTERS_FROM_URL';
export const SET_BOND_FIELDS_FROM_URL = 'SET_BOND_FIELDS_FROM_URL';